import { Dialog, Transition } from "@headlessui/react";
import { isEmpty } from "lodash";
import React, { Fragment, useEffect, useState } from "react";
import PlusIcon from "../../assets/svg/PlusIcon";
import { STORAGE_KEYS } from "../../Utils/constants";
import { getItem } from "../../Utils/Storage";
import { parseJwt } from "../../Utils/utils";
import { ContainerLogout } from "../LogoutButton";

export default function TokenCheck() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    addEventListener("popstate", () => handlePopSate(openModal));
    handlePopSate(openModal);

    return () => removeEventListener("popstate", () => handlePopSate(openModal));
  }, []);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as='div' className='relative z-[9999999999999]' onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100  backdrop-blur-sm'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-black/30' />
          </Transition.Child>

          <div className='fixed inset-0 overflow-y-auto flex'>
            <div className='flex min-h-full items-center justify-center p-4 text-center m-auto'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <Dialog.Panel className='w-full max-w-xs transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all'>
                  <div className='flex flex-col  space-y-2'>
                    <div className='text-4xl text-center'>⚠</div>
                    <Dialog.Title as='h3' className='text-lg text-center font-medium leading-6 text-gray-900'>
                      Session Expired
                    </Dialog.Title>
                  </div>

                  <button
                    className='top-4 active:bg-black/20 hover:bg-black/10 bg-white transition-opacity absolute right-6  stroke-2 text-black/50  hover:text-black/75 active:text-black rounded-full focus:outline-none p-2'
                    autoFocus={false}
                    onClick={closeModal}
                    title='Close'
                  >
                    <PlusIcon className='rotate-45  w-6 h-6' />
                  </button>

                  <div className='mt-6'>
                    <p className='text-sm text-gray-500 text-center'>
                      Your Session is expired, you have to login again to continue your journey
                    </p>
                  </div>

                  <div className='flex mt-8'>
                    <button
                      type='button'
                      className='mx-auto inline-flex justify-center rounded-md border border-transparent !bg-green-100 px-4 py-2 text-sm font-medium text-green-900 hover:bg-green-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2 transition-all'
                      autoFocus={true}
                      onClick={() => {
                        closeModal();
                        ContainerLogout();
                      }}
                    >
                      Goto Login Page
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

const handlePopSate = (openModal: () => void) => {
  // This will check if the user.token is valid or not
  if (!isEmpty(getItem(STORAGE_KEYS.AUTH_CONFIG)) && window.location.pathname !== "/login") {
    const user = getItem(STORAGE_KEYS.AUTH_CONFIG);

    const decodedJwt = parseJwt(user.access_token);
    if (decodedJwt.exp * 1000 < Date.now()) {
      openModal();
    }
  }
};
